"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var react_router_dom_1 = require("react-router-dom");
var crumb_nav_1 = __importDefault(require("../../components/crumb_nav"));
var handle_brightback_decision_1 = __importDefault(require("./components/handle-brightback-decision"));
var edit_bundle_panel_1 = __importDefault(require("./edit-bundle-panel"));
function EditBundle(props) {
    var _a, _b;
    var subId = (0, react_router_dom_1.useParams)().subId;
    var groupedSubscription = (_a = props.groupedSubscriptions) === null || _a === void 0 ? void 0 : _a.find(function (groupedSub) { return groupedSub.subscription.id === Number(subId); });
    var _c = __read((0, react_1.useState)(), 2), bundlerPreSelections = _c[0], setBundlerPreSelections = _c[1];
    var _d = __read((0, react_1.useState)(), 2), handleEditBundleModalClosed = _d[0], setHandleEditBundleModalClosed = _d[1];
    var _e = __read((0, react_1.useState)(), 2), handleSubscriptionUpdated = _e[0], setHandleSubscriptionUpdated = _e[1];
    if (props.isLoading) {
        return react_1.default.createElement(react_1.default.Fragment, null);
    }
    if (!groupedSubscription) {
        return (react_1.default.createElement("div", { className: 'grid-container' },
            react_1.default.createElement("div", null, "Sorry, this subscription url does not exist"),
            react_1.default.createElement("div", null,
                "To return to your main account page, please",
                react_1.default.createElement("div", null,
                    react_1.default.createElement("a", { href: '/account', className: 'text-wisteria text-underline' }, "click here"),
                    ' '))));
    }
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(handle_brightback_decision_1.default, { subId: subId, groupedSubscription: groupedSubscription, setBundlerPreSelections: setBundlerPreSelections, setHandleEditBundleModalClosed: setHandleEditBundleModalClosed, setHandleSubscriptionUpdated: setHandleSubscriptionUpdated }),
        react_1.default.createElement(crumb_nav_1.default, { current: "Editing ".concat(((_b = groupedSubscription.bundleInfo) === null || _b === void 0 ? void 0 : _b.name) ? "".concat(groupedSubscription.bundleInfo.name, "'s") : '', " Bundle") }),
        react_1.default.createElement(edit_bundle_panel_1.default, { bundlerPreSelections: bundlerPreSelections, groupedSubscription: groupedSubscription, customerData: props.customerData, onEditBundleModalClose: handleEditBundleModalClosed, onSubscriptionUpdated: handleSubscriptionUpdated })));
}
exports.default = EditBundle;
